import { render, staticRenderFns } from "./addswap.vue?vue&type=template&id=11c7048e"
import script from "./addswap.vue?vue&type=script&lang=js"
export * from "./addswap.vue?vue&type=script&lang=js"
import style0 from "./addswap.vue?vue&type=style&index=0&id=11c7048e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports